export default __webpack_public_path__ + "static/media/REEF.08ebe060.png";